import "jquery.dirty";

// Initialization of jquery.dirty plugin for specific element(question-part)
export function attachFormDirtyToTab(tab) {
    $(tab).dirty();
    $(tab).data('form-dirty', true);
}

// Check if part uses jquery.dirty plugin
export function hasFormDirty(tab) {
    return $(tab).data('form-dirty');
}

// Manual set part as always dirty even if nothing has been changed
export function forceSetDirty(tab) {
    $(tab).data('form-dirty-force-dirty', true);
}

// Check if part is manually set as always dirty
function isTabDirtyForced(tab) {
    return $(tab).data('form-dirty-force-dirty');
}

// Custom checking has part changed any form value
// but not survey category radio input
// or is part manually set as dirty
export function isTabDirty(tab) {
    function isChanged(tab) {
        return $(tab)
            .dirty("showDirtyFields")
            .toArray()
            .some((input) => $(input).not('.object-choose-radio').length);
    }

    return isTabDirtyForced(tab) || isChanged(tab);
}

// Set part inputs as clean(not changed)
export function setTabAsClean(tab) {
    if (hasFormDirty(tab)) {
        $(tab).dirty('setAsClean');
    }
}

// Set part as dirty(input values was changed)
export function setTabAsDirty(tab) {
    if (hasFormDirty(tab)) {
        $(tab).dirty('setAsDirty');
    }
}
